module.exports = __webpack_public_path__ + "img/mirrads-logo-dark.28086da7.png";